<app-accordion
  [tittle]="(dataList?.length ? title : noDataTitle) | translate"
  [arrow]="true"
  [show]="true"
  [toggle]="false"
  [class]="'text-primary-dark'"
>
  <div class="divider-dark"></div>

  <ion-grid class="ion-padding" *ngFor="let item of dataList">
    <ion-row>
      <ion-col size="6">
        <h4 regular class="text-primary-dark-50 ion-no-margin">{{ getItemName(item) }}</h4>
      </ion-col>
      <ion-col size="6">
        <h4 regular class="text-primary-dark-50 ion-no-margin">
          {{ getSignedStatus(item) | translate }}
        </h4>
      </ion-col>
      <div class="divider-dark"></div>
    </ion-row>
  </ion-grid>
</app-accordion>
